import React from 'react'

export const BlogRedirect = () => {
    React.useEffect(() => {
        window.location.href = (process.env.REACT_APP_BLOG_URL || '')
    }, [])

    return null;

}